import { InputHTMLAttributes } from 'react';
import { BoxProps, FormControlProps } from '@material-ui/core';

export enum EFileTypes {
  APPLICATION = 'application',
  IMAGE = 'image',
}

export enum EFileExtensions {
  PDF = 'pdf',
  PNG = 'png',
  JPG = 'jpg',
  JPEG = 'jpeg',
  GIF = 'gif',
  SVG = 'svg',
  DOC = 'doc',
  DOCX = 'docx',
  XLS = 'xls',
  XLSX = 'xlsx',
  PPT = 'ppt',
  PPTX = 'pptx',
  TXT = 'txt',
  CSV = 'csv',
  ZIP = 'zip',
  MP4 = 'mp4',
  MP3 = 'mp3',
  MOV = 'mov',
  OGG = 'ogg',
  WEBM = 'webm',
  APK = 'apk',
  EXE = 'exe',
}

export interface MinIOFile {
  downloadOptimizedUrl: string;
  downloadThumbnailUrl: string;
  downloadUrl: string;
  fileName: string;
}

export type Attachment = MinIOFile | File | string;

export interface FileInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  value?: Attachment[];
  label?: string;
  helperText?: string;
  FormControlProps?: FormControlProps;
  onChange?(files: Attachment[]): void;
}

export interface AttachedFileProps {
  file: Attachment;
  disabled?: boolean;
  onDelete?(): void;
}

export interface FilePreviewProps extends Pick<BoxProps, 'sx'> {
  file: Attachment;
}

export interface FileByTypePreviewProps extends FilePreviewProps {
  name: string;
  size: number;
  extension: EFileExtensions;
}
